import { render, staticRenderFns } from "./MultilingualInput.vue?vue&type=template&id=12235d2d&scoped=true&"
import script from "./MultilingualInput.vue?vue&type=script&lang=js&"
export * from "./MultilingualInput.vue?vue&type=script&lang=js&"
import style0 from "./MultilingualInput.vue?vue&type=style&index=0&id=12235d2d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12235d2d",
  null
  
)

export default component.exports